/*
  Validação do formulário de contato (#form-contato, ver wwwroot/index.html).
  Formulário curto — todo campo é essencial, então todos são obrigatórios.

  Ao enviar, se algo estiver faltando ou errado — nome incompleto, e-mail
  com formato inválido, "O que você procura?" sem escolher, empresa ou
  mensagem em branco — bloqueia o envio, destaca os campos com problema
  (.campo--invalido, ver src/sass/sections/_equipe.scss) e mostra uma
  modal de aviso (#validacao-modal) listando o que precisa ser
  corrigido. Sem erros, envia os dados para POST /api/contato e usa a mesma
  modal para informar sucesso ou uma falha temporária.
*/
(function () {
    var form = document.getElementById('form-contato');
    var modal = document.getElementById('validacao-modal');
    var lista = document.getElementById('validacao-lista');
    var titulo = document.getElementById('validacao-titulo');
    var botaoEnviar = form && form.querySelector('button[type="submit"]');
    if (!form || !modal || !lista || !titulo || !botaoEnviar) return;

    var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var NOME_COMPLETO_REGEX = /\S+\s+\S+/; // pelo menos duas "palavras" (nome + sobrenome)
    var DURACAO_ANIMACAO_MS = 450; // precisa bater com a transição da .validacao-caixa

    var campoNome = document.getElementById('contato-nome');
    var campoEmpresa = document.getElementById('contato-empresa');
    var campoEmail = document.getElementById('contato-email');
    var campoInteresse = document.getElementById('contato-interesse');
    var campoMensagem = document.getElementById('contato-mensagem');

    function marcaInvalido(campoInput) {
        var campo = campoInput.closest('.campo');
        if (campo) campo.classList.add('campo--invalido');
    }

    function limpaInvalido(campoInput) {
        var campo = campoInput.closest('.campo');
        if (campo) campo.classList.remove('campo--invalido');
    }

    // tira o destaque de erro assim que a pessoa mexe no campo de novo
    [campoNome, campoEmpresa, campoEmail, campoInteresse, campoMensagem].forEach(function (campo) {
        if (!campo) return;
        campo.addEventListener('input', function () { limpaInvalido(campo); });
        campo.addEventListener('change', function () { limpaInvalido(campo); });
    });

    function valida() {
        var erros = [];

        var nome = campoNome.value.trim();
        if (!nome) {
            erros.push('Conta seu nome pra gente saber com quem está falando.');
            marcaInvalido(campoNome);
        } else if (!NOME_COMPLETO_REGEX.test(nome)) {
            erros.push('Coloca seu nome completo (nome e sobrenome).');
            marcaInvalido(campoNome);
        }

        if (!campoEmpresa.value.trim()) {
            erros.push('Faltou o nome da sua empresa.');
            marcaInvalido(campoEmpresa);
        }

        var email = campoEmail.value.trim();
        if (!email) {
            erros.push('Faltou o seu e-mail.');
            marcaInvalido(campoEmail);
        } else if (!EMAIL_REGEX.test(email)) {
            erros.push('Esse e-mail não parece válido — confere se está certo.');
            marcaInvalido(campoEmail);
        }

        if (!campoInteresse.value) {
            erros.push('Escolhe uma opção em "O que você procura?".');
            marcaInvalido(campoInteresse);
        }

        if (!campoMensagem.value.trim()) {
            erros.push('Conta pra gente, mesmo que brevemente, sobre o projeto.');
            marcaInvalido(campoMensagem);
        }

        return erros;
    }

    function mostraMensagens(tituloModal, mensagens) {
        titulo.textContent = tituloModal;
        lista.innerHTML = '';
        mensagens.forEach(function (mensagem) {
            var li = document.createElement('li');
            li.textContent = mensagem;
            lista.appendChild(li);
        });

        modal.hidden = false;
        // força o navegador a "aplicar" o hidden=false antes de ligar a
        // classe que anima a entrada — senão cai tudo no mesmo frame
        modal.getBoundingClientRect();
        modal.classList.add('validacao-modal--visivel');
    }

    function fechaModal() {
        modal.classList.remove('validacao-modal--visivel');
        window.setTimeout(function () {
            modal.hidden = true;
        }, DURACAO_ANIMACAO_MS);
    }

    Array.prototype.slice.call(modal.querySelectorAll('[data-validacao-fechar]')).forEach(function (botao) {
        botao.addEventListener('click', fechaModal);
    });

    // clicar fora da caixa (no overlay escuro) também fecha — o
    // .validacao-backdrop só recebe o clique quando ele "sobra" fora da
    // .validacao-caixa (que tem z-index maior e cobre o próprio clique nela)
    var backdrop = modal.querySelector('.validacao-backdrop');
    if (backdrop) backdrop.addEventListener('click', fechaModal);

    // ESC também fecha, só quando a modal está aberta
    document.addEventListener('keydown', function (evento) {
        if (evento.key === 'Escape' && !modal.hidden) fechaModal();
    });

    function valor(id) {
        var campo = document.getElementById(id);
        return campo ? campo.value.trim() : '';
    }

    function mensagensDaResposta(resposta) {
        if (resposta && resposta.errors) {
            return Object.keys(resposta.errors).reduce(function (mensagens, chave) {
                return mensagens.concat(resposta.errors[chave]);
            }, []);
        }

        return [resposta && resposta.message
            ? resposta.message
            : 'Não foi possível enviar agora. Tente novamente em alguns instantes.'];
    }

    form.addEventListener('submit', async function (evento) {
        evento.preventDefault();

        var erros = valida();
        if (erros.length) {
            mostraMensagens('Só faltou isso...', erros);
            return;
        }

        var textoOriginal = botaoEnviar.textContent;
        botaoEnviar.disabled = true;
        botaoEnviar.textContent = 'Enviando...';

        var controller = new AbortController();
        var timeout = window.setTimeout(function () { controller.abort(); }, 20000);

        try {
            // ENVIO PARA O BACKEND:
            // esta rota chama o método SendAsync de Controllers/ContatoController.cs
            var respostaHttp = await fetch('/api/contato', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    nome: valor('contato-nome'),
                    empresa: valor('contato-empresa'),
                    email: valor('contato-email'),
                    interesse: valor('contato-interesse'),
                    mensagem: valor('contato-mensagem'),
                    utmSource: valor('contato-utm-source'),
                    utmMedium: valor('contato-utm-medium'),
                    utmCampaign: valor('contato-utm-campaign'),
                    utmContent: valor('contato-utm-content'),
                    landingPage: valor('contato-landing-page'),
                    referrer: valor('contato-referrer'),
                    website: valor('contato-website')
                }),
                signal: controller.signal
            });

            var resposta = await respostaHttp.json().catch(function () { return {}; });

            if (!respostaHttp.ok) {
                mostraMensagens('Não conseguimos enviar', mensagensDaResposta(resposta));
                return;
            }

            form.reset();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'generate_lead' });
            mostraMensagens('Mensagem enviada!', [
                'Obrigado pelo contato. Em breve, alguém da Salut! falará com você.'
            ]);
        } catch (erro) {
            mostraMensagens('Não conseguimos enviar', [
                erro.name === 'AbortError'
                    ? 'O envio demorou mais que o esperado. Tente novamente.'
                    : 'Verifique sua conexão e tente novamente em alguns instantes.'
            ]);
        } finally {
            window.clearTimeout(timeout);
            botaoEnviar.disabled = false;
            botaoEnviar.textContent = textoOriginal;
        }
    });
})();
